import { useEffect, useState, startTransition } from "react";
import DashbordStyles from "./Dashboard.module.scss";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import {
  getClauseCheckThunk,
  getContractsReviewThunk,
  uploadMutliDocFromBotThunk,
  setModalOpen,
} from "../../store/dashboard.thunk";
import { ClauseCheckFailedInfo } from "../../../../components/ClauseCheckFailedInfo/ClauseCheckFailedInfo";
import Typography from "../../../../components/Typography/Typography";
import {
  actionType,
  DASHBOARD_FEATURES,
  dashboardConfig,
  LANDING_PAGE_TO_DASHBOARD_URLS,
  VMO_BOT_FILE_UPLOAD_LIMIT,
} from "../../constants";
import { isEqual } from "underscore";
import { MimeTypes, ROUTES } from "../../../../common/constants";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import { UploadFileFromDriveBtn } from "../../../../components/Buttons/Buttons";
import { getToast, sliderSettings } from "../../../../common/utils";
import useDrivePicker from "react-google-drive-picker";
import UploadIcon from "../../../../assets/upload_white.svg";
import HomeStorageIcon from "../../../../assets/home_storage.svg";
import { Point } from "../../types";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getDraftedContractsCount } from "../../../../services/contracts.service";
import {
  getGeneratedRfxContractsForTable,
  getProjectMappings,
  getRfxEvaluationDataForTable,
} from "../../../../services/common.service";
import { getFilteredDashboardFeatures } from "../../utils";
import ShimmerDashboard from "./ShimmerDashboard";
import AstroBubble from "../../../../assets/Astro Assist bubble.svg";
import { initialPostCall } from "../../../../services/agent.service"; // Import the initialPostCall function
import workBenchIcon from "../../../../assets/Dashboard.svg";
import arrowForwardIcon from "../../../../assets/images/arrow_forward.svg";

const Dashboard = () => {
  const [projectName, setProjectName] = useState("");
  const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(false);
  const toggleDrawer =
    (open: boolean) => (event?: React.KeyboardEvent | React.MouseEvent) => {
      // Optionally handle keypress events
      if (
        event &&
        event.type === "keydown" &&
        "key" in event &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      setIsSideDrawerOpen(open);
    };
  useEffect(() => {
    const fetchProjectName = async () => {
      try {
        const response = await getProjectMappings();
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          // Prefer "Orion" if present, else default to first project
          const orionProject = response.project_names.find(
            (name: string) => name === "Orion"
          );
          setProjectName(orionProject || response.project_names[0]);
        }
      } catch (error) {
        console.error("Error fetching project name:", error);
      }
    };

    fetchProjectName();
  }, []);

  const { vmoBot } = useAppSelector(
    (state) => state.rootReducer.vscDashboardReducer
  );

  const dispatch = useAppDispatch();

  const profileData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.profileData?.data
  );

  const [selectedCard, setSelectedCard] = useState({});

  const isContracRedliningAllowed = profileData?.isContractReviewAllowed;
  const isClauseCheckAllowed = profileData?.isClauseCheckAllowed;
  const [isLoading, setIsLoading] = useState(true);
  const [exit, setExit] = useState(false);

  const handleClick = (cardData: any) => {
    setExit(true);
    if (cardData.headerText === DASHBOARD_FEATURES.CONTRACT_DRAFTING) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.contract_drafting}`
      );
    } else if (cardData.headerText === DASHBOARD_FEATURES.TALK_TO_CONTRACT) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.ttc}`
      );
    } else if (cardData.headerText === DASHBOARD_FEATURES.CLAUSE_CHECK) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.clause_check}`
      );
    } else if (cardData.headerText === DASHBOARD_FEATURES.CONTRACT_REDLINING) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining}`
      );
    } else if (cardData.headerText === DASHBOARD_FEATURES.RFX_EVALUATION) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.rfx_evaluation}`
      );
    } else if (cardData.headerText === DASHBOARD_FEATURES.RFX_GENERATOR) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.rfx_generator}`
      );
    } else if (
      cardData.headerText === DASHBOARD_FEATURES.REQUIREMENTS_GENERATOR
    ) {
      navigate(
        `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.requirements_generator}`
      );
    }
    setSelectedCard(cardData);
  };

  const [openPicker] = useDrivePicker();
  const [openingPicker, setOpeningPicker] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const handleFileUpload = async () => {
    dispatch(setModalOpen(true));
  };

  const handleCallBackResponse = async (data: {
    action: string;
    docs: any;
  }) => {
    switch (data.action) {
      case "picked":
        const { docs } = data;
        if (docs?.length > VMO_BOT_FILE_UPLOAD_LIMIT) {
          getToast(
            "Error",
            `Cannot upload more than ${VMO_BOT_FILE_UPLOAD_LIMIT} files`
          );
        } else {
          await dispatch(uploadMutliDocFromBotThunk(docs));
        }
        break;

      case "cancel":
      default:
        break;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const promises = [];
        if (
          // isContracRedliningAllowed

          isClauseCheckAllowed
        ) {
          promises.push(dispatch(getContractsReviewThunk()));
        }
        if (isClauseCheckAllowed) {
          promises.push(dispatch(getClauseCheckThunk({ polling: false })));
        }

        // Wait for all API calls to complete
        if (promises.length > 0) {
          await Promise.all(promises);
        }
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        // Add a slight delay to make the shimmer effect visible even on fast connections
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    };

    // Only load if we have profile data
    if (profileData) {
      loadData();
    }
  }, [dispatch, isClauseCheckAllowed, isContracRedliningAllowed, profileData]);

  let filteredDashboardFeatures = getFilteredDashboardFeatures(
    isClauseCheckAllowed,
    isContracRedliningAllowed
  );
  // DEBUG: Log the project name to ensure correct Requirements Generator visibility
  console.log("Current projectName:", projectName);
  // Only show Requirements Generator card if projectName is SourcingHub
  filteredDashboardFeatures = filteredDashboardFeatures.filter(
    (featureKey) => featureKey !== DASHBOARD_FEATURES.REQUIREMENTS_GENERATOR
  );
  if (projectName === "SourcingHub") {
    filteredDashboardFeatures.unshift(
      DASHBOARD_FEATURES.REQUIREMENTS_GENERATOR
    );
  }

  const sliderSettingsObj = {
    ...sliderSettings(),
    className: DashbordStyles.carouselContainer,
  };

  if (isLoading) {
    return (
      <ShimmerDashboard
        isContracRedliningAllowed={isContracRedliningAllowed}
        isClauseCheckAllowed={isClauseCheckAllowed}
      />
    );
  }

  return (
    <div
      className={`${DashbordStyles.dashboardContainer} ${exit ? "exit" : ""}`}
      style={
        isContracRedliningAllowed && !isClauseCheckAllowed
          ? {
              justifyContent: "flex-start",
            }
          : {}
      }
    >
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className={DashbordStyles.dashboardHeader}>
            Hey {profileData?.given_name},
          </div>
          <ClauseCheckFailedInfo />
        </div>
        <div className={DashbordStyles.dashboardSubHeader}>
          {/* {projectName === 'Orion' ? 'Welcome to Orion!' : 'Welcome to Orbit!'} */}
          {projectName === "Orion"
            ? "Welcome to Orion!"
            : projectName === "SourcingHub"
            ? "Welcome to Orion GSA!"
            : projectName === "Orbit"
            ? "Welcome to Orbit!"
            : ""}
        </div>
      </div>

      <div className={DashbordStyles.mainContent}>
        {isContracRedliningAllowed && !isClauseCheckAllowed ? (
          <div className={DashbordStyles.contractRedliningCardsContainer}>
            {filteredDashboardFeatures.map((featureKey) => {
              const cardData = dashboardConfig?.[featureKey];
              return (
                <div key={featureKey} className={DashbordStyles.cardWrapper}>
                  <HeaderCard
                    cardData={cardData}
                    handleClick={handleClick}
                    selectedCard={selectedCard}
                    urlActionType={actionType}
                    exit={exit}
                  />
                </div>
              );
            })}
          </div>
        ) : isLoading ? (
          filteredDashboardFeatures.map((featureKey) => {
            const cardData = dashboardConfig?.[featureKey];
            return (
              <div key={featureKey} className={DashbordStyles.cardWrapper}>
                <HeaderCard
                  cardData={cardData}
                  handleClick={handleClick}
                  selectedCard={selectedCard}
                  urlActionType={actionType}
                  exit={exit}
                />
              </div>
            );
          })
        ) : (
          <Slider {...sliderSettingsObj}>
            {filteredDashboardFeatures.map((featureKey) => {
              const cardData = dashboardConfig?.[featureKey];
              return (
                <div key={featureKey} className={DashbordStyles.cardWrapper}>
                  <HeaderCard
                    cardData={cardData}
                    handleClick={handleClick}
                    selectedCard={selectedCard}
                    urlActionType={actionType}
                    exit={exit}
                  />
                </div>
              );
            })}
          </Slider>
        )}
      </div>

      {isClauseCheckAllowed && (
        <div className={`${DashbordStyles.rightContent} ${exit ? "exit" : ""}`}>
          {projectName === "SourcingHub" ? (
            <div
              style={{
                background: "#fff",
                borderRadius: "24px",
                boxShadow: "0px 8px 24px 0px #00000014",
                padding: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                width: "100%",
                marginTop: 24,
              }}
              onClick={() =>
                startTransition(() => navigate("/workbench-dashboard"))
              }
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    alignItems: "center",

                    display: "flex",
                    height: "32px",
                    justifyContent: "center",

                    marginRight: "10px",
                  }}
                >
                  <img
                    src={workBenchIcon}
                    alt="My Dashboard"
                    style={{
                      width: 46,
                      height: 46,
                    }}
                  />
                </div>
                <div>
                  <div
                    style={{ fontSize: 20, fontWeight: 500, color: "#282b31" }}
                  >
                    My Dashboard
                  </div>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#7a7f89",
                      margin: 0,
                    }}
                  >
                    Generate a new requirement
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: 40,
                  height: 40,

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#fff",
                }}
              >
                <img
                  src={arrowForwardIcon}
                  alt="Go"
                  style={{
                    width: 24,
                    height: 24,
                    border: "1px solid #282b31",
                    borderRadius: "50%",
                    padding: 4,
                  }}
                />
              </div>
            </div>
          ) : (
            <UploadFileFromDriveBtn
              onClick={handleFileUpload}
              loading={openingPicker}
              disabled={openingPicker}
              fullWidth
              navigate={navigate}
            />
          )}
        </div>
      )}
    </div>
  );
};

const HeaderCard = ({
  cardData,
  handleClick,
  selectedCard,
  urlActionType,
  exit,
}: any) => {
  const {
    mainIcon,
    headerText,
    description,
    lightIcon,
    points,
    hoverText,
    hoverTextTwo,
  } = cardData;

  const [isHovered, setIsHovered] = useState(false);
  const [draftedContractsCount, setDraftedContractsCount] = useState(0);
  const [generatedRfxCount, setGeneratedRfxCount] = useState(0);
  const [evaluatedRfxCount, setEvaluatedRfxCount] = useState(0);
  const isActive = isEqual(selectedCard, cardData);
  const navigate = useNavigate();
  const isClauseCheck = cardData.headerText === DASHBOARD_FEATURES.CLAUSE_CHECK;
  const isContractRedlining =
    cardData.headerText === DASHBOARD_FEATURES.CONTRACT_REDLINING;
  const isTTC = cardData.headerText === DASHBOARD_FEATURES.TALK_TO_CONTRACT;
  const isRfxGenerator =
    cardData.headerText === DASHBOARD_FEATURES.RFX_GENERATOR;
  const isRfxEvaluation =
    cardData.headerText === DASHBOARD_FEATURES.RFX_EVALUATION;
  // const isBreathingDashboard =
  //   cardData.headerText === DASHBOARD_FEATURES.BREATHING_DASHBOARD;
  const { contractsReview, clauseCheck } = useAppSelector(
    (state) => state.rootReducer.vscDashboardReducer
  );

  const clauseCheckCounts = {
    total: clauseCheck?.user_docs[1].count + clauseCheck?.user_docs[0].count,
    completed: clauseCheck?.user_docs[1].count,
    pending: clauseCheck?.user_docs[0].count,
  };

  const contractRedliningCounts = {
    total:
      contractsReview?.user_docs[1].count + contractsReview?.user_docs[0].count,
    completed: contractsReview?.user_docs[1].count,
    pending: contractsReview?.user_docs[0].count,
  };

  const cardCounts: any = isClauseCheck
    ? clauseCheckCounts
    : contractRedliningCounts;

  const isDrafting =
    cardData.headerText === DASHBOARD_FEATURES.CONTRACT_DRAFTING;

  const getDraftContractsCount = async () => {
    const draftedContractCount = await getDraftedContractsCount();
    setDraftedContractsCount(draftedContractCount?.count_of_drafted_contracts);
  };

  const getGeneratedRfxCount = async () => {
    const generatedRfxList = await getGeneratedRfxContractsForTable({
      page_size: 10,
      page: 1,
    });
    setGeneratedRfxCount(generatedRfxList?.count);
  };

  const getEvaluatedRfxCount = async () => {
    const evaluatedRfxList = await getRfxEvaluationDataForTable({
      page_size: 10,
      page: 1,
    });
    setEvaluatedRfxCount(evaluatedRfxList?.count);
  };

  useEffect(() => {
    getDraftContractsCount();
    getGeneratedRfxCount();
    getEvaluatedRfxCount();
  }, []);

  const handleNavigation = (cardType: string, actionType: string) => {
    switch (cardType) {
      case DASHBOARD_FEATURES.TALK_TO_CONTRACT:
        navigate(
          `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.ttc}`
        );
        break;
      case DASHBOARD_FEATURES.CLAUSE_CHECK:
        if (actionType === urlActionType.UPLOAD) {
          navigate(
            `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.clause_check}&actionType=${actionType}`
          );
        } else if (actionType === urlActionType.HOME_STORAGE) {
          navigate(`${ROUTES.clauseSummary}`);
        }
        break;
      case DASHBOARD_FEATURES.CONTRACT_REDLINING:
        if (actionType === urlActionType.UPLOAD) {
          navigate(
            `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining}&actionType=${actionType}`
          );
        } else if (actionType === urlActionType.HOME_STORAGE) {
          navigate(`${ROUTES.manageContracts}`);
        }
        break;
      case DASHBOARD_FEATURES.CONTRACT_DRAFTING:
        navigate(
          `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.contract_drafting}`
        );
        break;
      case DASHBOARD_FEATURES.RFX_EVALUATION:
        navigate(
          `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.rfx_evaluation}`
        );
        break;
      case DASHBOARD_FEATURES.RFX_GENERATOR:
        navigate(
          `${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.rfx_generator}`
        );
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={`${DashbordStyles.card} ${
        isActive && DashbordStyles.selectedCard
      } ${isTTC && DashbordStyles.talkToContractCard} ${exit ? "exit" : ""}`}
      onClick={() => handleClick(cardData)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={DashbordStyles.headerContainer}>
        <div className={DashbordStyles.headerContent}>
          <div
            className={`${DashbordStyles.iconWrapper} ${
              isHovered && "hovered"
            }`}
          >
            <img
              src={mainIcon}
              alt={`${headerText} main icon`}
              height={16}
              width={16}
              style={{ marginRight: "8px", width: "20px", height: "20px" }}
              className={DashbordStyles.mainIcon}
            />
          </div>
          {cardData?.secondaryIcon && isHovered && (
            <img
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                height: "140px",
              }}
              src={cardData?.secondaryIcon}
              alt=""
            />
          )}
          <Typography
            fontSize={16}
            fontWeight={500}
            lineHeight={"25px"}
            className={DashbordStyles.headerText}
            sx={{ color: isHovered ? "white" : "#3474E0" }}
          >
            {headerText}
          </Typography>
        </div>
      </div>

      {/* Remove hover-only description and icons */}

      <div className={DashbordStyles.additionalContent}>
        <Typography
          fontSize={16}
          fontWeight={400}
          color="#000"
          lineHeight="18px"
          className={DashbordStyles.description}
        >
          {hoverText}
        </Typography>
      </div>
    </div>
  );
};

export default Dashboard;
